import { render, staticRenderFns } from "./LeaveType.vue?vue&type=template&id=2c62ea3c"
import script from "./LeaveType.vue?vue&type=script&lang=js"
export * from "./LeaveType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports